import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {

  title: 'Output',
  attributeName: 'outputFormGroup',
  fields: [
    {
      attributeName: 'hls_enable',
      type: FormInputTypes.CHECKBOX,
      label: 'Generate HLS manifest',
      helpText: 'Check if you want to generate HLS manifest.',
      default: false,
      errorText: '',
       disabledWhenEdit:true,
    },
    {
      attributeName: 'signaling_disable',
      type: FormInputTypes.CHECKBOX,
      label: 'Signaling Disable',
      helpText: 'Checked if you want to disable the signaling in the video output.',
      default: false,
      errorText: '',
      disabledWhenEdit: true,
    },

     {
      attributeName: 'mp3_extraction',
      type: FormInputTypes.CHECKBOX,
      label: 'MP3 Extraction',
      helpText: 'Marked if you want to extract MP3 audio from the video.',
      default: false,
      errorText: '',
      disabledWhenEdit:true,

    },
    {
      attributeName: 'lightweight_video',
      type: FormInputTypes.CHECKBOX,
      label: 'Lightweight Video',
      helpText: 'Checked if you want to create a lightweight version of the video.',
      default: false,
      errorText: '',
      disabledWhenEdit:true,

    },
    {
      attributeName: 'video_preview',
      type: FormInputTypes.CHECKBOX,
      label: 'Video Preview',
      helpText: 'Checked if you want to generate a video preview.',
      default: false,
      errorText: '',
      disabledWhenEdit:true,

    },
  ]
};
